<template>
  <ModalConfirmation
    :showClose="false"
    :isSubmitButtonLoading="isSubmitting"
    @close="$emit('close')"
    @confirm="onConfirmAwayStatus"
    :isShowConfirmDeleteMessage="false">
    <div slot="custom_warning">
      <template v-if="!isAway">
        <h4>{{ i18n.confirm_away_title }}</h4>
        <p class="pad-1 italic pad-0-top">{{ i18n.confirm_away_text }}</p>
      </template>
      <template v-else>
        <h4>{{ i18n.confirm_unaway_title }}</h4>
        <p class="pad-1 italic">{{ i18n.confirm_unaway_text }}</p>
      </template>
    </div>
    <p slot="confirmText">{{ !isAway ? i18n.mark_as_away : i18n.unmark_as_away }}</p>
  </ModalConfirmation>
</template>

<script>
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import docendo from '../../docendo'

const I18N = {
  da: {
    mark_as_away: 'Markér som ude af huset',
    unmark_as_away: 'Fortryd markering som ude af huset',
    confirm_away_title: 'Er du sikker på, at du vil markere lektionen som ude af huset?',
    confirm_away_text: 'Lektionen vil blive markeret som værende uden for skolens område. Og personale på lektionen vil fremgå i vikardækningen som fraværende.',
    confirm_unaway_text: 'Lektionen vil ikke længere fremgå som ude af huset. Og personale vil ikke længere fremgå i vikardækningen som fraværende.',
    confirm_unaway_title: 'Er du sikker på, at du vil fortryde markeringen som ude af huset?'
  },
  no: {
    mark_as_away: 'Marker som utenfor skolen',
    unmark_as_away: 'Angre markering som utenfor skolen',
    confirm_away_title: 'Er du sikker på at du vil markere leksjonen som utenfor skolen?',
    confirm_away_text: 'Leksjonen vil bli markert som værende utenfor skolens område. Og personalet på leksjonen vil vises i vikaroversikten som fraværende.',
    confirm_unaway_title: 'Er du sikker på at du vil angre markeringen som utenfor skolen?',
    confirm_unaway_text: 'Leksjonen vil ikke lenger vises som ute av huset. Og personalet vil ikke lenger vises i vikaroversikten som fraværende.'
  },
  en: {
    mark_as_away: 'Mark as out of school',
    unmark_as_away: 'Undo out of school marking',
    confirm_away_title: 'Are you sure you want to mark the event as out of school?',
    confirm_away_text: 'The event will be marked as taking place outside the school premises. And staff in the event will appear in the substitute management as absent.',
    confirm_unaway_text: 'The event will no longer be shown as taking place outside the school. And staff will no longer appear in the substitute management as absent.',
    confirm_unaway_title: 'Are you sure you want to undo the out of school marking?'
  }
}

export default {
  components: {ModalConfirmation},
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    eventIdProp: {
      default: 'event_id'
    }
  },
  data () {
    return {
      isSubmitting: false
    }
  },
  computed: {
    isAway () {
      return this.event.away
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N.en // Fallback til engelsk, hvis sproget ikke er defineret
    }
  },
  methods: {
    onConfirmAwayStatus () {
      this.handleConfirmAwayStatus()
    },
    handleConfirmAwayStatus () {
      this.isSubmitting = true
      const updatedLesson = {
        school_id: this.event.school_id,
        updates: [{event_id: this.event[this.eventIdProp], away: !this.isAway}]
      }
      docendo.updateEvents(
        updatedLesson.school_id,
        updatedLesson.updates,
        success => {
          this.isSubmitting = false
          this.$emit('updated')
        },
        failure => {
          console.log('failed')
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// DModalOutOfSchoolLesson.vue?1bb1376c